import React from 'react';
import './footer.scss'

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2021 LMT | <a href="https://github.com/LydiaMT/resty" rel="noreferrer noopener" target="_blank">GITHUB</a></p>
    </footer>
  )
};

export default Footer;
